import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import DataPurchasesFleetModal from '../../../../components/management/fleets/auxModals/DataPurchasesFleetModal'
import { closeDataPurchasesFleetModal, fetchSalesmanCombos, fetchSalesTypeCombo } from '../../../../actions/management/auxModals/auxModals'
import {
  fetchOperationType, fetchFleetOperationTypeForAutoselect, fetchAdditionalInfoCombo, fetchVehicleType,
  fetchPurchaseType, fetchRentingEntityCombo, fetchTuneUpDestination, fetchStockStatusCombo,
  fetchPurchaseOrderTypeCombo, fetchSaleTypeAll, fetchPuscharseSaleEntitys
} from '../../../../actions/combos/combos'
import { openDocumentEditionModal } from '../../../../actions/dossier/common/documentEditionModal'
import dossierSalesActions from '../../../../actions/dossier/sales'
import { checkPurchaseTypeAndSetDefaultEntity } from '../../../../actions/dossier/purchase'
import { fetchPaymentCombo, fetchOperateDataFleetModalsPermissions } from '../../../../actions/management/management'
import { setOperateDataPurchaseFleetProcess } from '../../../../actions/unattendedProcess/unattendedProcess'
import { openModal } from '../../../../actions/common'
import { buttonsSidebar } from '../../../../constants/dossier/common/buttonsSidebar'
import TrackingContainer from '../../../tracking/trackingContainer'

export function mapStateToProps (state) {
  return {
    ...state.managementAuxModals.dataPurchasesFleetModal,
    componentConfiguration: state.management.operateFleetModal.componentsModalConfiguration ? state.management.operateFleetModal.componentsModalConfiguration.componentsConfiguration.find(x => x.code === buttonsSidebar.bpurchase) : null,
    combos: {
      ...state.combos,
      paymentMethodCombo: state.management.paymentCombo
    }
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      closeDataPurchasesFleetModal,
      fetchOperationType,
      fetchFleetOperationTypeForAutoselect,
      openDocumentEditionModal,
      fetchSalesmanCombos,
      fetchAdditionalInfoCombo,
      fetchPaymentCombo,
      fetchSalesTypeCombo,
      fetchOperateDataFleetModalsPermissions,
      setOperateDataPurchaseFleetProcess,
      fetchVehicleType,
      openModal,
      fetchPurchaseType,
      fetchRentingEntityCombo,
      fetchTuneUpDestination,
      fetchStockStatusCombo,
      fetchPurchaseOrderTypeCombo,
      fetchSaleTypeAll,
      fetchPuscharseSaleEntitys,
      ...dossierSalesActions,
      checkPurchaseTypeAndSetDefaultEntity
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(TrackingContainer(DataPurchasesFleetModal, true)))
